import React, { FunctionComponent } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import Icon from '../../components/Icon';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  style?: StyleProp<ViewStyle>;
  onPress(): void;
}

const CloseButton: FunctionComponent<IProps> = (
  {
    onPress,
    style,
  },
) => (
  <TouchableOpacity
    hitSlop={{
      bottom: defaultScale(20), top: defaultScale(20), left: defaultScale(20), right: defaultScale(20),
    }}
    onPress={onPress}
    style={style}
  >
    <Icon
      name='md-close'
      color={Theme.GREY}
      size={defaultScale(30)}
    />
  </TouchableOpacity>
);

export default CloseButton;
